import './App.css';

function SuccessPage() {
  return (
    <div className="App">
      <header className="header">
        <div className="header-content">
          <span className="site-name">Bidder <span className="brand-blue">iQ</span></span>
        </div>
      </header>

      <main>
        <section className="hero success-hero">
          <div className="success-icon">✓</div>
          <h1>Thank You for Your Purchase!</h1>
          <p className="hero__subtitle">
            We're excited to have you advertise on Bidder iQ.<br />
            We'll be reaching out shortly to get started.
          </p>
        </section>

        <section className="next-steps-section">
          <h2>What We'll Need From You</h2>
          <div className="next-steps-grid">
            <div className="next-step-card">
              <div className="next-step-icon">🖼️</div>
              <h3>Your Logo</h3>
              <p>High-resolution image (PNG or SVG preferred)</p>
            </div>
            <div className="next-step-card">
              <div className="next-step-icon">🏢</div>
              <h3>Company Name</h3>
              <p>As you'd like it displayed</p>
            </div>
            <div className="next-step-card">
              <div className="next-step-icon">📝</div>
              <h3>Short Description</h3>
              <p>A brief tagline or description of your business</p>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <h2>Questions?</h2>
          <p>Feel free to reach out anytime:</p>
          <a href="mailto:david@bidderiq.com" className="button-primary">david@bidderiq.com</a>
        </section>
      </main>

      <footer className="footer">
        <p>&copy; 2026 Bidder iQ. All rights reserved.</p>
      </footer>
    </div>
  );
}

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get('success') === 'true';

  if (isSuccess) {
    return <SuccessPage />;
  }

  const demographics = [
    { percent: '89%', label: 'Over 45 yrs old' },
    { percent: '97%', label: 'Male' },
    { percent: '55%', label: 'Income >$250k' },
    { percent: '88%', label: 'Net Worth >$1m' },
    { percent: '84%', label: "Bachelor's Degree+" },
    { percent: '95%', label: 'Own Real Estate' },
    { percent: '56%', label: 'Own >4 Cars' },
    { percent: '96%', label: 'Frequent Travel for Leisure' },
  ];

  return (
    <div className="App">
      <header className="header">
        <div className="header-content">
          <span className="site-name">Bidder <span className="brand-blue">iQ</span></span>
        </div>
      </header>

      <main>
        <section className="hero">
          <h1>Reach Thousands of Porsche<br />Collectors Each Month</h1>
          <p className="hero__subtitle">Social feeds are noisy and search is crowded. Bidder iQ puts your brand<br />in front of buyers when real money decisions are being made.</p>
        </section>

        <section className="inquiry-section">
          <h2>Interested in Advertising?</h2>
          <p className="inquiry-subtitle">Get in touch to learn about available ad placements and pricing.</p>
          <p className="inquiry-email">Email Me: <strong>david@bidderiq.com</strong></p>
        </section>

        <section className="demographics-section">
          <h2>Audience Demographics</h2>
          <p className="section-subtitle">2025 User Survey</p>
          <div className="demographics-grid">
            {demographics.map((item, index) => {
              const value = parseInt(item.percent);
              const circumference = 2 * Math.PI * 45;
              const offset = circumference - (value / 100) * circumference;
              return (
                <div className="demo-card" key={index}>
                  <div className="demo-circle">
                    <svg className="demo-ring" viewBox="0 0 100 100">
                      <circle className="demo-ring-bg" cx="50" cy="50" r="45" />
                      <circle 
                        className="demo-ring-progress" 
                        cx="50" 
                        cy="50" 
                        r="45"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                      />
                    </svg>
                    <div className="demo-percent">{item.percent}</div>
                  </div>
                  <div className="demo-label">{item.label}</div>
                </div>
              );
            })}
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>&copy; 2026 Bidder iQ. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
